
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { OrderWithItems } from 'common-models';

import { FC, useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import PageIsLoading from "../../components/PageIsLoading";
import { useGetOrderQuery } from '../../features/events/eventShopApiSlice';



const OrderReceiptPage: FC<any> = () => {
    const params = useParams();
    const orderId = params.orderId as string;

    const { data = undefined as unknown as OrderWithItems } = useGetOrderQuery(orderId);

    const [order, setOrder] = useState(undefined as unknown as OrderWithItems);

    useEffect(() => {
        if (data !== undefined) {
            console.info(data);
            setOrder(data);
        }
    }, [data])

    const getFormattedOrderTime = (input: Date) => {
        const time = new Date(input);
        return `${time.getFullYear()}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${(time.getDate()).toString().padStart(2, '0')} ${(time.getHours()).toString().padStart(2, '0')}:${(time.getMinutes()).toString().padStart(2, '0')}`
    }

    return (
        <Root>
            {order === undefined ? (
                <PageIsLoading />
            ) : (
                <Grid container >
                    <Grid size={{ md: 2, lg: 3, xl: 4 }}>

                    </Grid>
                    <Grid size={{ md: 8, lg: 6, xl: 4 }}>

                        <Typography align='center' variant='h1'>Kvitto</Typography>
                        <Grid container>
                            Orderdatum / tid: {getFormattedOrderTime(order.createdTime)}
                        </Grid>
                        <TableContainer>
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Beskrivning</TableCell>
                                        <TableCell align='right'>Pris</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        order.items.map(x => {
                                            return (
                                                <TableRow key={x.id}>
                                                    <TableCell>{x.product.productId} ({x.imageId})</TableCell>
                                                    <TableCell align='right'>{x.product.prices.find(y => y.id === x.appliedPriceId)?.priceInSekExclVat}</TableCell>
                                                </TableRow>
                                            )
                                        })

                                    }
                                    <TableRow className={classes.dividerAbove}>
                                        <TableCell>Summa (exkl. moms)</TableCell>
                                        <TableCell align='right'>{order.totalSum}</TableCell>
                                    </TableRow>
                                    <TableRow >
                                        <TableCell>Moms (25%)</TableCell>
                                        <TableCell align='right'>{order.totalSum * 0.25}</TableCell>
                                    </TableRow>
                                    <TableRow className={classes.dividerAbove} >
                                        <TableCell>TOTALT</TableCell>
                                        <TableCell align='right'>{order.totalSum * 1.25}</TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Grid container>
                            Order-id: {order.id}
                        </Grid>
                        <Grid container>
                            Mindbound AB (organisationsnummer 559249-9403)
                        </Grid>
                    </Grid>
                    <Grid size={{ md: 2, lg: 3, xl: 4 }}>

                    </Grid>

                </Grid >

            )
            }
        </Root>
    );
};



const PREFIX = 'OrderReceiptPage';
const classes = {
    cartItemsContainer: `${PREFIX}-cartItemsContainer`,
    swishLogo: `${PREFIX}-swishLogo`,
    sendMailButton: `${PREFIX}-sendMailButton`,
    table: `${PREFIX}-table`,
    dividerAbove: `${PREFIX}-dividerAbove`,
}

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.cartItemsContainer}`]: {
        minWidth: '400px'
    },
    [`&.${classes.swishLogo}`]: {
        width: '60px',
        marginRight: '1rem'
    },
    [`&.${classes.sendMailButton}`]: {
        marginLeft: '1rem !important'
    },
    [`&.${classes.table}`]: {
        fontSize: '1rem',
    },
    [`&.${classes.dividerAbove}`]: {
        borderTopWidth: '3px',
        borderTopStyle: 'solid',
        borderTopColor: theme.palette.primary.light
    },
}));

export default OrderReceiptPage;
